export default async function validationResolver(formState: any, existingData: any) {
  const data = { ...formState }
  const existingFields = { ...existingData };
  delete data.tipping_enabled;
  delete existingFields.tipping_enabled;
  delete existingFields.tipping;

  function checkValueIsUnique(formState: any) {
    const output: { [key: string]: any } = {};

    const percentItems = Object.entries(formState)
      .filter(([key, item]: any) => (
        item?.tip_type === "PERCENTAGE" && item?.enabled
      ))
      .reduce((acc: any, [key, item]: any) => {
        const existingArr = acc?.[item.value] ?? [];
        return {
          ...acc,
          [item.value]: [...existingArr, key]
        }
      }, {})

    Object.values(percentItems).forEach((item: any) => {
      if (item.length >= 2) {
        item.forEach((key: string) => {
          if(parseInt(formState[key].value)===0){
            output[key] = { name: key, type: 'validation', message: 'tipping.percentError' }
          }
          else output[key] = { name: key, type: 'validation', message: 'tipping.customTipUniqueError' }
        });
      }
    });

    return output;
  }

  function checkForEmptyValues(data: any) {
    return Object.entries(data).reduce((acc: any, [key, item]: any) => {
      if (item?.enabled && item?.tip_type === "PERCENTAGE") {
        if(parseInt(item?.value) === 0){
          return {
            ...acc,
            [key]: { name: key, type: 'validation', message: 'tipping.percentError' },
          }
        }
        else if (!item?.value) {
          return {
            ...acc,
            [key]: { name: key, type: 'validation', message: 'tipping.notFilled' },
          }
        }
      }

      return acc;
    }, {});
  }

  function mergeErrors(errors: any) {
    return errors.reduce((acc: any, curr: any) => {
      return {
        ...acc,
        ...curr,
      }
    }, {})
  }

  const pipeline = [checkForEmptyValues, checkValueIsUnique]
  const finishedPipeline = pipeline.map((fn: any) => fn(data))
  const errors = mergeErrors(finishedPipeline);
  const hasErrors = !!Object.keys(errors).length

  return {
    values: hasErrors ? {} : { tipping: data, tipping_enabled: formState.tipping_enabled },
    errors: hasErrors ? errors : {},
  };
}
